import React from 'react';
import { Calendar } from 'lucide-react';
export function Appointments() {
  return <div className="p-8 max-w-7xl mx-auto flex flex-col items-center justify-center min-h-[60vh] text-center" data-id="element-30">
      <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-6" data-id="element-31">
        <Calendar className="w-10 h-10 text-blue-500" data-id="element-32" />
      </div>
      <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-33">
        No Appointments Yet
      </h1>
      <p className="text-slate-500 max-w-md" data-id="element-34">
        You haven't booked any appointments. Find a doctor to schedule your
        first consultation.
      </p>
      <button className="mt-8 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium transition-colors" data-id="element-35">
        Find a Doctor
      </button>
    </div>;
}